export default __webpack_public_path__ + "static/media/esagono.5ca8b788.svg";